import { atom } from "recoil";

const pointsState = atom({
  key: "pointsState",
  default: 0,
});

export default pointsState;
